export const ADMIN_ROLE = "1";
export const MANAGER_ROLE = "2";
export const EXECITUVE_ROLE = "3";
export const FRONTOFFICE_ROLE = "4";
export const TRAINER = "6";
